import { Form } from "antd";
import i18n from "i18next";
import { useParams } from "react-router";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { TextInput } from "../Text/TextInput";
import { SiteIdGenerator } from "./SiteIdGenerator";

export const SiteIdGeneratorField: FieldMethod = ({ field, readOnly, rules }: FormFieldFactoryProps) => {
    const { id } = useParams();

    return (
        <Form.Item noStyle shouldUpdate={() => true}>
            {({ getFieldValue }) => {
                const siteGroupId = getFieldValue("parentUnit");

                return !id && siteGroupId ? (
                    <Form.Item key={`${field.name}FormItem`} name={field.name} rules={rules}>
                        <SiteIdGenerator
                            key={field.name}
                            readOnly={readOnly}
                            siteGroupId={siteGroupId}
                            label={i18n.t(field.translationKeys.label)}
                            name={field.name}
                        />
                    </Form.Item>
                ) : (
                    <Form.Item key={`${field.name}FormItem`} name={field.name} rules={rules}>
                        <TextInput key={field.name} name={field.name} label={field.translationKeys.label} readOnly />
                    </Form.Item>
                );
            }}
        </Form.Item>
    );
};
